
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetonashikcabs() {



    const cardData =
    {
        keyword: 'Pune to Nasik Cabs',
        heading: 'Mauli Cabs: Pune to Nasik Cabs',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Nasik cabs, ensuring a smooth and enjoyable journey to one of Maharashtra’s most popular pilgrimage and tourism destinations. Whether you are visiting Nasik for religious purposes, wine tours, or sightseeing, we provide a range of vehicles including sedans, SUVs, and premium cars to suit your travel needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and pleasant ride from Pune to Nasik.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Sula Vineyards",
        "description": "Sula Vineyards is one of India's most renowned wineries, offering guided tours, wine tastings, and a picturesque setting overlooking the vineyards. It's a must-visit for wine enthusiasts and those seeking a serene escape."
    },
    {
        "title": "Saptashrungi Devi Temple",
        "description": "Located approximately 60 km from Nashik, this temple is perched atop a hill with seven peaks, offering panoramic views of the surrounding landscape. It's a significant religious site dedicated to Goddess Saptashrungi."
    },
    {
        "title": "Trimbakeshwar Temple",
        "description": "An important pilgrimage site, this temple is dedicated to Lord Shiva and is one of the twelve Jyotirlingas. It's located in the town of Trimbak, about 28 km from Nashik."
    },
    {
        "title": "Pandav Leni Caves",
        "description": "These ancient Buddhist rock-cut caves, dating back to the 1st century BCE, are located on the Trirashmi Hill. The site offers a glimpse into the region's rich Buddhist heritage."
    },
    {
        "title": "Ramkund",
        "description": "Ramkund is a sacred bathing ghat on the banks of the Godavari River in Nashik. It's a significant site for religious rituals and is closely associated with the Kumbh Mela."
    },
    {
        "title": "Anjneri Hill",
        "description": "Believed to be the birthplace of Lord Hanuman, Anjneri Hill offers trekking opportunities and panoramic views of the surrounding area. It's a blend of natural beauty and spiritual significance."
    },
    {
        "title": "Gargoti Mineral Museum",
        "description": "Located in Sinnar, about 32 km from Nashik, this museum houses India's largest collection of zeolite minerals and crystals. It's the only gem and mineral museum in India."
    },
    {
        "title": "Kalaram Temple",
        "description": "Situated in the Panchavati area of Nashik, this temple is dedicated to Lord Rama and is an important pilgrimage site. It's known for its historical significance and serene ambiance."
    },
    {
        "title": "Dugarwadi Waterfalls",
        "description": "Located about 30 km from Nashik, Dugarwadi Waterfalls is a hidden gem offering a tranquil environment amidst nature. It's an ideal spot for nature lovers and trekkers."
    },
    {
        "title": "Muktidham Temple",
        "description": "This temple complex in Nashik is dedicated to various Hindu deities and is known for its architectural beauty and peaceful surroundings."
    }
],

"services": [
    {
      "name": "Pune to Nasik Cab Service",
      "description": "Book a reliable and affordable cab service for your journey from Pune to Nasik. Travel in comfort and style with our professional drivers."
    },
    {
      "name": "Affordable Cabs Pune to Nasik",
      "description": "Enjoy an affordable cab service from Pune to Nasik with a range of vehicles to suit your budget and comfort needs."
    },
    {
      "name": "Pune to Nasik Sula Wine Yards",
      "description": "Take a scenic ride from Pune to the famous Sula Wine Yards in Nasik. Our comfortable cabs will ensure a pleasant journey to this popular destination."
    },
    {
      "name": "Pune to Nasik Car Rental",
      "description": "Rent a car for your trip from Pune to Nasik. Choose from a variety of vehicles and enjoy a comfortable journey with our reliable car rental services."
    },
    {
      "name": "Pune Nasik Taxi Service",
      "description": "Book a taxi from Pune to Nasik for a smooth, safe, and reliable travel experience. Our service includes experienced drivers and timely arrivals."
    },
    {
      "name": "Pune to Nasik Airport Cabs",
      "description": "Book an airport taxi from Pune to Nasik for quick and comfortable transportation. We ensure timely pick-up and drop-off to meet your flight schedule."
    },
    {
      "name": "Pune to Nasik Outstation Cabs",
      "description": "Enjoy a hassle-free ride with our outstation cabs from Pune to Nasik. Our cabs are comfortable, safe, and perfect for long-distance travel."
    },
    {
      "name": "Pune to Nasik Cab Booking Online",
      "description": "Book your Pune to Nasik cab online with ease. Our simple and secure online booking process ensures a smooth travel experience."
    },
    {
      "name": "Nasik Dudhsagar Water Falls Taxi",
      "description": "Take a taxi from Pune to the beautiful Dudhsagar Water Falls in Nasik. Enjoy a scenic drive and breathtaking views along the way."
    },
    {
      "name": "Pune to Nasik Private Cabs",
      "description": "Book a private cab for your trip from Pune to Nasik. Travel in privacy, comfort, and style with our dedicated private cab services."
    },
    {
      "name": "Pune Nasik One-Way Taxi",
      "description": "Need a one-way ride from Pune to Nasik? Our one-way taxi service ensures a quick and comfortable journey at affordable rates."
    },
    {
      "name": "Pune to Nasik Round Trip Cabs",
      "description": "Book a round-trip cab service from Pune to Nasik. Travel back and forth with a reliable and comfortable taxi service at competitive rates."
    },
    {
      "name": "Pune to Nasik Cabs",
      "description": "Book a cab from Pune to Nasik for a comfortable and seamless ride. Our cabs are available for both short and long-distance travel."
    },
    {
      "name": "Cab From Pune to Nasik",
      "description": "Get a cab from Pune to Nasik with Mauli Cabs. Our drivers ensure a safe and pleasant journey, making your trip comfortable and stress-free."
    },
    {
      "name": "Nashik to Pune Private Car",
      "description": "Book a private car from Nasik to Pune for a comfortable and personalized travel experience. Our premium vehicles ensure luxury and convenience."
    },
    {
      "name": "Nasik to Pune Cab Booking",
      "description": "Book your cab from Nasik to Pune with ease. We offer reliable and timely cabs for a smooth and enjoyable ride."
    },
    {
      "name": "Nasik to Pune Cab Service",
      "description": "Choose our Nasik to Pune cab service for a comfortable and efficient ride. Our drivers ensure safety and a hassle-free journey."
    },
    {
      "name": "Nasik to Pune Cabs",
      "description": "Travel conveniently from Nasik to Pune with our reliable cab service. We provide affordable and comfortable travel options for your trip."
    },
    {
      "name": "Nasik to Pune Taxi",
      "description": "Book a taxi from Nasik to Pune for a smooth, timely, and comfortable ride. We offer the best in class services to meet your travel needs."
    },
    {
      "name": "Pune Nashik Taxi",
      "description": "Book a taxi for your journey from Pune to Nashik. Our taxis are equipped with modern amenities and driven by professional drivers."
    },
    {
      "name": "Pune Nasik Cab",
      "description": "Book a cab for your trip from Pune to Nasik with ease. Our cab services ensure comfort, reliability, and convenience."
    },
    {
      "name": "Pune Nasik Taxi",
      "description": "Get a taxi from Pune to Nasik with our reliable service. We provide fast, affordable, and comfortable rides to your destination."
    },
    {
      "name": "Pune to Nasik Taxi",
      "description": "Travel in comfort with our Pune to Nasik taxi service. Enjoy a hassle-free ride to one of the most popular destinations near Pune."
    },
    {
      "name": "Taxi from Pune to Nasik",
      "description": "Book a taxi for your journey from Pune to Nasik. Our service ensures that you travel safely, comfortably, and on time."
    },
    {
      "name": "Pune Airports to Nasik Cabs",
      "description": "Need a cab from Pune Airport to Nasik? We provide fast, comfortable, and affordable transportation from the airport to your destination."
    },
    {
      "name": "Pune to Nasik Cabs Round Trip",
      "description": "Book a round trip cab from Pune to Nasik for your travel needs. Enjoy a comfortable journey with an easy return trip at your convenience."
    },
    {
      "name": "Pune to Nasik Cabs Round Trip Contact Number",
      "description": "Need to book a round-trip cab from Pune to Nasik? Call us at [Contact Number] for booking assistance and details."
    },
    {
      "name": "Pune Airport to Nasik Cabs",
      "description": "Book a cab from Pune Airport to Nasik for a smooth and timely airport transfer. We offer comfortable rides at competitive prices."
    },
    {
      "name": "Pune Airport to Trimbakeshwar Cab Booking",
      "description": "Book a cab from Pune Airport to Trimbakeshwar Temple for a spiritual journey. Our taxi service ensures a safe, comfortable ride."
    }
  ],
  "tableData": [
    ["Pune to Nasik Cab Service", "Affordable Cabs Pune to Nasik"],
    ["Pune to Nasik Sula Wine Yards", "Pune to Nasik Car Rental"],
    ["Pune Nasik Taxi Service", "Pune to Nasik Airport Cabs"],
    ["Pune to Nasik Outstation Cabs", "Pune to Nasik Cab Booking Online"],
    ["Nasik Dudhsagar Water Falls Taxi", "Pune to Nasik Private Cabs"],
    ["Pune Nasik One-Way Taxi", "Pune to Nasik Round Trip Cabs"],
    ["Pune to Nasik Cabs", "Cab From Pune to Nasik"],
    ["Nashik to Pune Private Car", "Nasik to Pune Cab Booking"],
    ["Nasik to Pune Cab Service", "Nasik to Pune Cabs"],
    ["Nasik to Pune Taxi", "Pune Nashik Taxi"],
    ["Pune Nasik Cab", "Pune Nasik Taxi"],
    ["Pune to Nasik Taxi", "Taxi from Pune to Nasik"],
    ["Pune Airports to Nasik Cabs", "Pune to Nasik Cabs Round Trip"],
    ["Pune to Nasik Cabs Round Trip Contact Number", "Pune Airport to Nasik Cabs"],
    ["Pune Airport to Trimbakeshwar Cab Booking", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Nasik journey. Our professional drivers ensure punctual pickups and drop-offs, so you can reach your destination on time, whether it's for business or leisure."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We provide a variety of comfortable and spacious vehicles for your Pune to Nasik cab ride. From air-conditioned sedans to roomy SUVs, each vehicle is maintained to the highest standards for a comfortable and pleasant ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-versed with the Pune to Nasik route. They ensure a smooth and safe journey by navigating the best routes, avoiding traffic, and providing you with a comfortable ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for your Pune to Nasik cab booking. With no hidden charges, you can be sure of getting an affordable and transparent price for your trip."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure you have a secure and pleasant journey from Pune to Nasik."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Nasik trip. Whether you're booking early in the morning or late at night, our customer service team is always ready to assist with your ride."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Nasik cab with Mauli Cabs is easy and hassle-free. You can book online via our website or mobile app, or contact our customer service team for personalized assistance and a seamless booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Nasik trip. Whether it's a business trip, a pilgrimage, or a weekend getaway, we can tailor the trip to meet your specific needs and preferences."
    }
]














    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Nasik with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Nasik with Mauli Cabs is simple! You can book through our website or mobile app by entering your pickup location (Pune) and destination (Nasik), and selecting your preferred vehicle. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Nasik route?',
            answer: 'Mauli Cabs offers a variety of vehicles for the Pune to Nasik route, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the vehicle that suits your comfort and space requirements for a smooth and enjoyable journey.',
        },
        {
            question: 'Is the fare for Pune to Nasik cabs fixed?',
            answer: 'Yes, the fare for the Pune to Nasik trip is fixed and transparent. The fare includes tolls, taxes, and driver charges, with no hidden costs. The total fare will be displayed upfront before you confirm your booking.',
        },
        {
            question: 'Can I book a round trip from Pune to Nasik?',
            answer: 'Yes, you can easily book a round trip for your journey from Pune to Nasik. Just provide your return details during the booking process, and we’ll take care of the rest, ensuring a smooth journey back.',
        },
        {
            question: 'How long does the journey from Pune to Nasik take?',
            answer: 'The journey from Pune to Nasik typically takes around 4 to 5 hours, depending on traffic conditions. Our experienced drivers are familiar with the best routes to ensure a timely and comfortable ride.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Nasik route?',
            answer: 'Yes, all Mauli Cabs drivers are professional, experienced, and familiar with the best routes between Pune and Nasik. They prioritize your safety and comfort throughout the journey.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Nasik?',
            answer: 'Yes, you can customize your journey by making stops along the way for breaks or sightseeing. Our drivers are happy to accommodate your requests and ensure your trip is pleasant.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Nasik trip?',
            answer: 'Yes, all our cabs for the Pune to Nasik journey are fully air-conditioned and well-maintained to ensure comfort and cleanliness. We prioritize hygiene and ensure a pleasant ride every time.',
        },
        {
            question: 'Can I cancel or modify my booking for Pune to Nasik?',
            answer: 'Yes, you can easily cancel or modify your booking for Pune to Nasik. We offer a flexible cancellation policy through our website or app, and our customer support team is available to assist you as needed.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Nasik trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and a commitment to punctuality. Whether you are traveling for business or leisure, we ensure a comfortable, safe, and hassle-free journey from Pune to Nasik.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Raghav Joshi",
            position: "Business Professional",
            text: "I traveled from Pune to Nasik with Mauli Cabs, and the service was excellent. The vehicle was clean and comfortable, the driver was professional, and the journey was smooth. I will definitely book with them again for my future trips!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Ananya Gupta",
            position: "Leisure Traveler",
            text: "I had a wonderful trip from Pune to Nasik with Mauli Cabs. The booking process was easy, the driver was friendly and knowledgeable, and the car was well-maintained. I highly recommend Mauli Cabs for anyone traveling to Nasik!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Nasik Cabs Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Nasik, including one-way and round-trip options. Book private, luxury, or outstation taxis for sightseeing trips to destinations like Sula Wine Yards and Dudhsagar Water Falls. Enjoy a smooth, reliable ride with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      

    return (
        <div>
            <GTag/>
<Helmet>
        <title>Pune to Nasik Cabs | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Nasik cab with Mauli Cabs. Choose from affordable, private, luxury, and outstation taxi options for one-way or round-trip travel. Visit popular destinations like Sula Wine Yards and Dudhsagar Water Falls with our reliable and comfortable taxi service."
        />
        <meta
          name="keywords"
          content="Pune to Nasik Cab Service, Affordable Cabs Pune to Nasik, Pune to Nasik Sula Wine Yards, Pune to Nasik Car Rental, Pune Nasik Taxi Service, Pune to Nasik Airport Cabs, Pune to Nasik Outstation Cabs, Pune to Nasik Cab Booking Online, Nasik Dudhsagar Water Falls Taxi, Pune to Nasik Private Cabs, Pune Nasik One-Way Taxi, Pune to Nasik Round Trip Cabs, Pune to Nasik Cabs, Cab From Pune to Nasik, Nashik to Pune Private Car, Nasik to Pune Cab Booking, Nasik to Pune Cab Service, Nasik to Pune Cabs, Nasik to Pune Taxi, Pune Nashik Taxi, Pune Nasik Cab, Pune Nasik Taxi, Pune to Nasik Taxi, Taxi from Pune to Nasik, Pune Airports to Nasik Cabs, Pune to Nashik Cabs Round Trip, Pune to Nashik Cabs Round Trip Contact"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonashikcabs;